import Clickable from '@carvana/merch-components/Clickable';
import { CarvanaTheme } from '@carvana/theme';
import styled from 'styled-components';

export const MapLegendSearchAreaContainer = styled.div`
  width: 100%;
  top: 0;
  left: 0;
  position: relative;
  text-align: center;
  background-color: ${CarvanaTheme.carvana.blue.medium};

  @media (min-width: ${CarvanaTheme.breakpoints.values.lg}px) {
    top: 50px;
    max-width: 350px;
    position: relative;
    left: 5%;
    max-width: unset;
    min-width: unset;
    height: auto;
    width: 350px;
    border-radius: 4px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
  }
`;

export const MapLegendListContainer = styled.div`
  width: 100%;
  bottom: 0;
  left: 0;
  text-align: center;
  max-height: 683px;
  height: 683px;

  @media (min-width: ${CarvanaTheme.breakpoints.values.lg}px) {
    top: 50px;
    max-width: 350px;
    position: relative;
    left: 5%;
    max-width: unset;
    min-width: unset;
    height: auto;
    width: 350px;
  }
`;

export const MapLegendSearchAreaHeader = styled.div`
  padding: 32px;
  color: #ffffff;
  font-family: 'Brandon Text';
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 26px;
  text-align: center;
  text-transform: uppercase;
  width: 100%;
  display: inline-block;
  padding-bottom: 24px;

  @media (min-width: ${CarvanaTheme.breakpoints.values.sm}px) {
    width: 50%;
    vertical-align: top;
    padding-bottom: 32px;
  }
  @media (min-width: ${CarvanaTheme.breakpoints.values.lg}px) {
    width: 100%;
    padding-bottom: 24px;
  }
`;

export const MapLegendSearchAreaHeaderInnerContainer = styled.div`
  @media (min-width: ${CarvanaTheme.breakpoints.values.sm}px) {
    display: flex;
    align-items: center;
    height: 56px;
  }
  @media (min-width: ${CarvanaTheme.breakpoints.values.lg}px) {
    width: 100%;
    display: block;
    height: unset;
  }
`;

export const LocationMarkerIconWrapper = styled.div`
  margin-bottom: 16px;

  @media (min-width: ${CarvanaTheme.breakpoints.values.sm}px) {
    margin-right: 16px;
    margin-bottom: unset;
  }
  @media (min-width: ${CarvanaTheme.breakpoints.values.lg}px) {
    width: 100%;
    display: block;
    padding-bottom: 16px;
  }
`;

export const MapLegendSearchAreaHeaderText = styled.h2`
  flex: 5;
  font-size: 24px;
  font-weight: bold;

  @media (min-width: ${CarvanaTheme.breakpoints.values.sm}px) {
    display: flex;
    text-align: left;
    margin-bottom: 0px;
  }
  @media (min-width: ${CarvanaTheme.breakpoints.values.lg}px) {
    display: block;
    text-align: center;
  }
`;

export const MapLegendSearchAreaInputWrapper = styled.div`
  padding-bottom: 32px;
  padding-top: 0px;
  display: inline-block;
  width: 100%;
  padding-left: 1em;
  padding-right: 1em;
  vertical-align: top;

  @media (min-width: ${CarvanaTheme.breakpoints.values.sm}px) {
    padding-top: 32px;
    width: 50%;
  }
  @media (min-width: ${CarvanaTheme.breakpoints.values.lg}px) {
    padding-top: 0px;
    width: 100%;
  }
`;

export const LegendLocations = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  position: absolute;
  bottom: 32px;
  left: 0;
  overflow-x: scroll;
  width: 100%;
  padding-left: 25px;

  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Internet Explorer 10+ */

  &::-webkit-scrollbar {
    /* WebKit/Chrome */
    width: 0;
    height: 0;
  }

  @media (min-width: ${CarvanaTheme.breakpoints.values.lg}px) {
    flex-direction: column;
    width: 100%;
    max-height: 600px;
    background-color: #ffffff;
    overflow-y: scroll;
    scrollbehavior: 'smooth';
    backgroundcolor: '#ffffff';
    bottom: unset;
    padding-left: unset;
    overflow-x: hidden;

    border-radius: 4px;
    border-top-right-radius: 0px;
    border-top-left-radius: 0px;
  }
`;

type LegendLocationItemProps = {
  isActive: boolean;
};

export const LegendLocationItem = styled(Clickable)<LegendLocationItemProps>`
  height: 136px;
  width: 295px;
  min-width: 295px;
  margin-right: 20px;
  background-color: ${props =>
    props.isActive ? `${CarvanaTheme.carvana.blue.pastel}` : '#ffffff'};
  font-family: Brandon Text;
  font-style: normal;
  font-size: 16px;
  line-height: 24px;
  position: relative;
  border-radius: 4px;
  box-shadow: 0px 6px 13px rgba(24, 53, 88, 0.1);
  border-bottom: 1px solid #d9dde9;

  @media (min-width: ${CarvanaTheme.breakpoints.values.lg}px) {
    width: 100%;
    margin-right: unset;
    border-radius: unset;
  }
`;

export const LegendLocationItemInnerContainer = styled.div`
  margin: 20px;
  text-align: left;
  min-height: 4em; // set to 6em when we add directions/moreinfo row
`;

export const LegendLocationItemTitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: ${CarvanaTheme.carvana.blue.dark};
`;

export const LegendLocationItemAddress = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${CarvanaTheme.carvana.gray.dark};
  margin-left: 1.5em;
  cursor: pointer;
`;

export const LegendLocationItemDistance = styled.div`
  position: absolute;
  top: 20px;
  right: 1.5em;
  font-size: 14px;
  line-height: 20px;
  color: ${CarvanaTheme.carvana.gray.dark};
`;

export const LegendLocationItemLinkDirections = styled.span`
  margin-left: 1.5em;

  color: ${CarvanaTheme.carvana.blue.primary};
`;

export const LegendLocationItemLinkMoreInfo = styled.span`
  position: absolute;
  right: 40px;
  color: ${CarvanaTheme.carvana.blue.primary};
`;

export const LegendLocationItemBottomRow = styled.div`
  font-size: 14px;
  line-height: 20px;
  position: absolute;
  bottom: 20px;
  width: 100%;
`;
